import { render, staticRenderFns } from "./ListFoot.vue?vue&type=template&id=a91730d8&scoped=true&"
import script from "./ListFoot.vue?vue&type=script&lang=js&"
export * from "./ListFoot.vue?vue&type=script&lang=js&"
import style0 from "./ListFoot.vue?vue&type=style&index=0&id=a91730d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91730d8",
  null
  
)

export default component.exports